import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_RETIREMENT_SETTINGS);

const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    getRetirementSettings: (state) => {
        if (state.data) {
            return state.data
        } else {
            this.fetchAll()
        }
    },
    editMode: (state) => {
        return state.editMode
    },
    record: (state) => {
        return state.record
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    addRetirementSettings: (state, payload) => {
        state.data = payload;
    },

    updateRetirementSettingsById: (state, payload) => {
        for (let i = 0; i < state.data.data.length; i++) {
            if (state.data.data[i][_pk_name] === payload.id) {
                state.data.splice(i, 1, payload);
            }
        }
    },

    removeRetirementSettingsById: (state, payload) => {
        for (let i = 0; i < state.data.data.length; i++) {
            if (state.data.data[i][_pk_name] == payload) {
                state.data.data.splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post(`/`, {
                data: payload
            });
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addRetirementSettings", res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/`, {
                data: payload
            });
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateRetirementSettingsById", res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeRetirementSettingsId", payload.id);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}